import React from 'react';
import { Metric } from '../types';

interface CustomChartRendererProps {
  metric: Metric;
}

const CustomChartRenderer: React.FC<CustomChartRendererProps> = ({ metric }) => {
  if (metric.chart_type === 'custom' && metric.chart_image_url) {
    return (
      <div className="bg-dark-navy p-4 rounded-lg">
        <div className="mb-3">
          <h4 className="text-lg font-semibold text-light">{metric.metric_name}</h4>
          {metric.chart_description && (
            <p className="text-sm text-medium-gray mt-2">{metric.chart_description}</p>
          )}
        </div>
        
        <div className="mt-4">
          <img 
            src={metric.chart_image_url} 
            alt={metric.metric_name} 
            className="w-full h-auto rounded border border-navy-blue"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"><rect width="400" height="300" fill="%23334155"/><text x="50%" y="50%" fill="%2394a3b8" font-family="Arial" font-size="16px" text-anchor="middle">Chart image failed to load</text></svg>';
            }}
          />
        </div>
        
        <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
          <div className="bg-deep-navy/60 p-2 rounded">
            <h5 className="text-medium-gray">X-axis</h5>
            <p className="text-light">{metric.x_label}</p>
          </div>
          <div className="bg-deep-navy/60 p-2 rounded">
            <h5 className="text-medium-gray">Y-axis</h5>
            <p className="text-light">{metric.y_label}</p>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="text-center py-10 text-medium-gray">
      This is not a custom chart
    </div>
  );
};

export default CustomChartRenderer;